import TokensView from './tokensView'

export default TokensView
